import { useSyncExternalStore } from 'react';

import auth from '../client';
import type { AuthState } from '../types';

const subscribeToAuth = (listener: () => void) => auth.subscribe(listener);
const getAuthState = () => auth.getState();

const authMethods = {
  startLogin: (...args: Parameters<typeof auth.startLogin>) => auth.startLogin(...args),
  completeLoginIfNeeded: (...args: Parameters<typeof auth.completeLoginIfNeeded>) =>
    auth.completeLoginIfNeeded(...args),
  getAccessToken: (...args: Parameters<typeof auth.getAccessToken>) => auth.getAccessToken(...args),
  getFreshAccessToken: (...args: Parameters<typeof auth.getFreshAccessToken>) => auth.getFreshAccessToken(...args),
  logout: (...args: Parameters<typeof auth.logout>) => auth.logout(...args),
  isAuthenticated: (...args: Parameters<typeof auth.isAuthenticated>) => auth.isAuthenticated(...args),
  updateProfile: (...args: Parameters<typeof auth.updateProfile>) => auth.updateProfile(...args),
  consumeNotice: (...args: Parameters<typeof auth.consumeNotice>) => auth.consumeNotice(...args),
};

export function useAuthState() {
  return useSyncExternalStore<AuthState>(subscribeToAuth, getAuthState, getAuthState);
}

export function useAuth() {
  const state = useAuthState();

  return {
    ...state,
    ...authMethods,
  };
}
